import {AxiosResponse} from 'axios';
import {EntitySocialResponse} from '../backend/interfaces/entity-social-response';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';
import {PaginatedArrayResponse} from './interfaces/paginated-array-response';

export class EntitySocialResponsesRepository {
  // Singleton Instance
  private static _instance: EntitySocialResponsesRepository;

  // Private
  private logger: Logger;

  static get instance(): EntitySocialResponsesRepository {
    if (!this._instance) {
      this._instance = new EntitySocialResponsesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntitySocialResponsesRepository');
  }

  // Get entity social responses
  public async getEntitySocialResponses(
    entityId: string | undefined,
    limit: number,
    skip: number
  ): Promise<PaginatedArrayResponse<EntitySocialResponse>> {
    const id = entityId || '000000000000000000000000';
    const response: AxiosResponse<EntitySocialResponse[]> = await BackendApiManager.instance.get<
      EntitySocialResponse[]
    >(`/entities/${id}/social-responses?limit=${limit}&skip=${skip}`);

    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }

  // Get all social responses that a target entity user has access to
  public async getUserSocialResponses(
    entityId: string,
    userId: string
  ): Promise<EntitySocialResponse[]> {
    const response: AxiosResponse<EntitySocialResponse[]> = await BackendApiManager.instance.get<
      EntitySocialResponse[]
    >(`/entities/${entityId}/users/${userId}/social-responses`);

    return response.data;
  }
}
